import Api from "../apiService";

class CatalogItemsApi {
  index(companyId, params = {}) {
    return Api.getRequest(
      `companies/${companyId}/catalog/items`,
      params,
      Api.authHeaders()
    );
  }

  show(companyId, id) {
    return Api.getRequest(
      `companies/${companyId}/catalog/items/${id}`,
      {},
      Api.authHeaders()
    );
  }

  create(companyId, data) {
    return Api.postRequest(
      `companies/${companyId}/catalog/items`,
      data,
      Api.authHeaders()
    );
  }

  update(companyId, id, data) {
    return Api.patchRequest(
      `companies/${companyId}/catalog/items/${id}`,
      data,
      Api.authHeaders()
    );
  }

  archive(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/catalog/items/${id}/archive`,
      {},
      Api.authHeaders()
    );
  }

  restore(companyId, id) {
    return Api.patchRequest(
      `companies/${companyId}/catalog/items/${id}/restore`,
      {},
      Api.authHeaders()
    );
  }
}

export default new CatalogItemsApi();
